// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__CDU1b","this":"styles_this__1pyd-","closeButton":"styles_closeButton__2ArKd","icon":"styles_icon__H1dWu"};